// @flow
import { PREBOOKING_FORM } from 'Client/cms/toolkit/constants';
import { PrebookingFormLine } from 'Components/lines/prebooking-form-line/PrebookingFormLine';
import { prebookingFormResolver } from './prebookingForm.resolver';

export const prebookingFormDescriptor = {
  name: PREBOOKING_FORM,
  component: PrebookingFormLine,
  resolve: prebookingFormResolver.resolve,
};
